import hillo from "hillo"

import i18n from '@/plugins/locales/i18n'
import {GlobalConfig, isFastFoodMode, setTableName, TableName} from '@/dataLayer/repository/GlobalSettingManager'
import dayjs from "dayjs";
import {shouldShowHotpotPanel} from "@/dataLayer/repository/HotpotViewmodel";
import store from "@/plugins/store";
import {Remember} from "@/plugins/firebase";
import IKUtils from "innerken-js-utils";


export async function openTableWithScanQR(tableId, isTakeaway = false) {
  try {
    return (await hillo.post('Complex.php?op=openTableWithScanQR', {
      tableId,
      overrideConsumeTypeId: isTakeaway ? 2 : GlobalConfig.ConsumeTypeId,
    }, {silent: true}))
  } catch (e) {
    return {
      status: 'bad',
      info: e.message
    }
  }

}

export function getTableName() {
  return TableName
}


export async function getCurrentInfo() {
  const tableId = (await getTableInfo()).id
  try {
    return (await hillo.silentGet('Tables.php?op=currentInfo', {id: tableId})).content
  } catch (e) {
    return {order: {consumeTypeStatusId: -1}}
  }
}

export async function dishesInTable() {
  const tableId = (await getTableInfo()).id
  try {
    return (await hillo.silentGet('Complex.php?op=dishesInTable',
      {tableId, lang: GlobalConfig.requestLocale})).content
  } catch (e) {
    return []
  }
}

export async function getTableInfo() {
  const tableName = getTableName()
  if (!tableName) {
    return null
  } else {
    return (await hillo.silentGet('Tables.php', {name: tableName}))?.content[0]
  }
}

export async function getOrderStatus() {
  const orderId = Remember.orderId
  if (!orderId) return {billOrderInfo: null, billInfo: null}
  return await hillo.silentGet('BackendData.php?op=billDetail', {id: orderId})
}

export async function requireCheckOut() {
  const tableId = (await getTableInfo()).id
  return (await hillo.get('Complex.php?op=requireCheckOut',
      {lang: i18n.locale, tableId})
  ).content
}

export async function orderDish(order) {
  let tableId
  if (isFastFoodMode()) {
    const orderStatus = await getOrderStatus()
    console.log(orderStatus)
    if (!(orderStatus?.billOrderInfo) || orderStatus.billInfo.consumeTypeStatusId > 4) {
      const res = await openTableWithScanQR(null, Remember.takeawayMode === 1)
      if (res.status === 'good' && res?.content?.tableName) {
        Remember.orderId = res.content.orderId
        setTableName(res.content.tableName)
      } else {
        IKUtils.showError("Error on open table, info:" + res.info)
        return
      }
      tableId = res?.content.tableId
    } else {
      tableId = orderStatus?.billInfo.tableId
    }

  } else {
    tableId = (await getTableInfo())?.id
  }
  if (!tableId) {
    IKUtils.showError("Wrong table information: " + tableId);
    return false
  }
  const haveFSDish = order.find(it => it.code === 'FS')
  if (haveFSDish) {
    const shouldAddFSDish = await shouldShowHotpotPanel()
    if (!shouldAddFSDish) {
      order = order.filter(it => it.code !== 'FS')
    } else {
      haveFSDish.count = 1
    }
  }
  if (store.state.needAcceptAllOrder === '1') {
    await callServant(tableId)
  }
  return await hillo.post('Complex.php?op=addDishesToTable', {
    params: JSON.stringify(order),
    tableId: tableId,
    printingKitchenBon: print ? 1 : 0,
    pending: store.state.needAcceptAllOrder === '1' ? 1 : 0
  })
}

export async function callServant(tableId) {
  return (await hillo.get('Complex.php?op=callServant', {
    tableId,
    lang: i18n.locale
  }))
}


export async function getRestaurantInfo() {
  return (await hillo.get('Restaurant.php?op=view')).content[0]
}


export const cloudUrl = 'https://cloud5.api.aaden.io'

export async function getBaseAndUrlForDeviceId(deviceId) {
  const url = (await findDeviceByDeviceId(deviceId))
    ?.baseUrl ?? getNgrokUrl(deviceId)
  return {
    deviceId,
    url
  }
}

export function getNgrokUrl(deviceId) {
  deviceId = deviceId.toString()
  return `ik${deviceId.padStart(4, '0')}.ngrok.aaden.io`
}

export async function findDeviceByDeviceId(deviceId) {
  try {
    return (await hillo.jsonPost(cloudUrl + '/virtualDevice/search', {deviceId: deviceId})).data?.[0]
  } catch (e) {
    console.log(e)
    return null
  }
}

export async function sendMailTo(mailTo, uuid) {
  try {
    await hillo.jsonPost('https://sendinvoicemail-evhwqutgjq-ey.a.run.app', {
      mailTo,
      uuid,
      templateId: 'z3m5jgr8xpoldpyo'
    })
  } catch (e) {
    console.log(e, 'e')
  }
}

export async function checkElectronicBillingStatus() {
  return (await hillo.get('Complex.php?op=checkAadenPoint', {})).content.enabled
}

export async function forceGetSystemSetting(item) {
  return (await hillo.post('Restaurant.php?op=forceGetSystemSetting', {
    systemSetting: JSON.stringify(item)
  })).content
}

export async function getCurrentConsumeTypeId() {
  return (await forceGetSystemSetting({
    section: 'qrApp',
    sKey: 'currentConsumeTypeId',
    sValue: '-1',
    defaultValue: '-1',
    sType: 'string',
    minimumVersion: '1.7.784',
    sOptions: '',
    tagList: 'basic,qrApp'
  }))
}

export async function loadPaymentMethods() {
  return (await hillo.get('PayMethod.php')).content
}


export async function notifyCheckout(amount, payMethodId, tableId) {
  const paymentLog = JSON.stringify([{id: payMethodId, price:amount}])
  await hillo.post('Complex.php?op=checkOut', {
    tableId,
    paymentLog,
    withTitle: 0,
    printCount: 1,
  })
}

/**
 * @param {{deviceId: number}} data
 */
export async function reportToCloud(data) {
  const defaultData = {
    name: '', ip: '', uuid: '', version: '', frontendType: '', deviceId: '',
  };
  const {
    name,
    ip,
    uuid,
    version,
    frontendType,
    deviceId,
  } = Object.assign({}, defaultData, data);
  const frontendLogDTO = {
    name,
    ip,
    uuid,
    version,
    frontendType,
    deviceId,
    timestamp: dayjs().valueOf()
  };
  await hillo.jsonPost("https://cloud-v2.aaden.io/api/frontend-logs/save", frontendLogDTO)
}


export async function getImageCache() {
  try {
    return await hillo.get("https://cloud-v2.aaden.io/api/dish-images/by-device/" + GlobalConfig.DeviceId)
  } catch (e) {
    return []
  }

}

export async function lockSubmitOrder() {
  return (await hillo.jsonPost("https://lockqrtable-evhwqutgjq-ey.a.run.app", {
    deviceId: GlobalConfig.DeviceId,
    tableId: (await getTableInfo()).id,
  }))?.data
}
